import React from 'react'
import { formTypeList } from '../../constants/form'
import StoreCreditForm from './StoreCreditForm'

const EditStoreCredit = ({ storeCredit, setOpen }) => {
    return storeCredit ? (
        <StoreCreditForm
            formType={formTypeList.EDIT}
            setOpen={setOpen}
            propsValue={storeCredit}
        />
    ) : null
}

export default EditStoreCredit
